import axios from "axios"
import Config from "./config"

const Request = axios.create({
  baseURL: Config.baseURL,
  timeout: 6000, // 请求超时时间
})

Request.interceptors.response.use(
  (response) => response.data,
  (err) => Promise.reject(err)
)

export function postAction(url, parameter) {
  return Request({
    url: url,
    method: "post",
    data: parameter,
  })
}

export function getAction(url, parameter) {
  return Request({
    url: url,
    method: "get",
    params: parameter,
  })
}
